import PropTypes from "prop-types";

import Grid from "@mui/material/Grid";

import MDBox from "components/atoms/MDBox";

function CenterFragment({ content, children }) {
  return (
    <>
      <MDBox px={1} width="100%" height="100vh" mx="auto">
        <Grid
          container
          spacing={1}
          justifyContent="center"
          alignItems="center"
          height="100%"
        >
          <Grid item xs={11} sm={9} md={5} lg={4} xl={3}>
            {content}
          </Grid>
        </Grid>
      </MDBox>
      {children}
    </>
  );
}

// Typechecking props for the BackgroundLayout
CenterFragment.propTypes = {
  content: PropTypes.node.isRequired,
  children: PropTypes.node,
};

export default CenterFragment;
